// Module Federation entry point
// Dynamic import creates async boundary for shared dependency negotiation
import("./bootstrap");
